module.exports = __webpack_public_path__ + "assets/img/32_623.2f55fd45.jpg";